import type { MouseEvent } from "react";
import { memo } from "react";
import { styled } from "styled-components";

import { BrowseInnerContent } from "domains/knowledgeData/components/SharedComponents";
import { KnowledgeDetailButton } from "domains/publication/components/KnowledgeDetailButton";
import type { Source } from "entities/knowledge/types";

const StyledLink = styled.a`
  align-items: center;
  color: ${({ theme }) => theme.colors.textBright};
  display: flex;
  justify-content: space-between;
  text-decoration: none;
`;

const StyledHeader = styled.div`
  text-decoration: none;
  display: flex;
`;

type KnowledgeDataItemBrowseViewProps = {
  className?: string;
  isSelected?: boolean;
  title: string;
  imageUrl?: string;
  source: Source;
  timestamp?: number;
  link?: string;
  onClick: () => void;
  onDetailLinkClick: (event: MouseEvent) => void;
};

export const KnowledgeDataItemBrowseView = memo(
  ({ title, imageUrl, source, timestamp, link, onDetailLinkClick, onClick }: KnowledgeDataItemBrowseViewProps) => (
    <StyledLink href="#" role="group" onClick={onClick} aria-label={`Open media player for ${title}`}>
      <StyledHeader>
        <BrowseInnerContent title={title} imageUrl={imageUrl} source={source} timestamp={timestamp} />
      </StyledHeader>
      {link && <KnowledgeDetailButton link={link} onClick={onDetailLinkClick} title={title} />}
    </StyledLink>
  ),
);

KnowledgeDataItemBrowseView.displayName = "KnowledgeDataItemBrowseView";
